import { Component, ViewChild, ElementRef, OnInit } from '@angular/core'

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {
  @ViewChild('menu') menu: ElementRef<HTMLElement>

  constructor() { }

  ngOnInit () {
    this.menu.nativeElement.setAttribute('menu', '')
  }

  toggle () {
    const element = this.menu.nativeElement
    element.setAttribute('menu', element.getAttribute('menu') === '' ? 'visible' : '')
  }
}
